import React from "react";
import {
  Body1,
  Card,
  Caption1,
  Subtitle2,
  makeStyles,
  tokens
} from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    display: "grid",
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalL,
    borderLeft: `${tokens.strokeWidthThick} solid ${tokens.colorPaletteRedBorder2}`,
    backgroundColor: tokens.colorPaletteRedBackground1,
    borderRadius: tokens.borderRadiusMedium,
  },
});

interface ContactPublisherCalloutProps {
  title?: string;
  description?: string;
}

export const ContactPublisherCallout: React.FC<ContactPublisherCalloutProps> = ({
  title = "Need help from the publisher?",
  description = "If this problem persists, contact the publisher for support and include your tenant and subscription details."
}) => {
  const styles = useStyles();

  return (
    <Card appearance="filled-alternative">
      <div className={styles.root}>
        <Subtitle2>{title}</Subtitle2>
        <Body1>{description}</Body1>
        <Caption1>Share the exact error message to help the publisher investigate faster.</Caption1>
      </div>
    </Card>
  );
};
